"use strict";
/**
 * APIRole.ts
 * Represents the API version of ERole enum
 *
 * This is a direct copy of ERole since enums don't require transformations
 * but keeping it in APIModels maintains consistency and decoupling from database models
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIRole = void 0;
var APIRole;
(function (APIRole) {
    APIRole["SUPERADMIN"] = "superadmin";
    APIRole["ADMIN"] = "admin";
    APIRole["SELLER"] = "seller";
    APIRole["EXTERNAL_SELLER"] = "external_seller";
    APIRole["PRODUCTION_DEPT"] = "production_dept";
    APIRole["PRODUCTION_WORKER"] = "production_worker";
})(APIRole || (exports.APIRole = APIRole = {}));
